import logo from "../assets/K-Logo.webp";
import bgImg from "../assets/bgIMG.webp";
import cheerful from "../assets/cheerful.webp";
import circle_bg from "../assets/circle.svg";
import emailimg from "../assets/email.webp";
import lebanon from "../assets/lebanon.webp";
import myImg2 from "../assets/myImage.webp";
import nextjs3 from "../assets/nextjs3.webp";
import node from "../assets/node.webp";
import react from "../assets/react.webp";
import syria from "../assets/syria.webp";
export default {
  logo,
  emailimg,
  lebanon,
  syria,
  myImg2,
  circle_bg,
  cheerful,
  node,
  nextjs3,
  react,
  bgImg,
};
